export const FORM_FIELD_RULES = {
    USERNAME_REQUIRED: "Username is required",
    PASSWORD_REQUIRED: "Password is required"
};
